<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { debounce } from '@chatwoot/utils';
import SearchInboxSelector from 'dashboard/modules/search/components/SearchInboxSelector.vue';
import SearchDateRangeSelector from 'dashboard/modules/search/components/SearchDateRangeSelector.vue';

// FEAT-020: filter bar for the Contact Timeline modal. Reuses the same
// inbox/date-range selectors the global search page already has, but not
// SearchInput.vue — that component drags in a recent-searches localStorage
// panel and a document-wide "/" keybinding meant for a full-page search
// experience, neither of which fits inside a modal. A plain debounced input
// covers the "search by text" case here without that baggage (see DEC-052).
const emit = defineEmits(['change']);

const { t } = useI18n();

const q = ref('');
const inboxId = ref(null);
const dateRange = ref({ type: null, from: null, to: null });

const currentFilters = () => ({
  q: q.value,
  inbox_id: inboxId.value,
  since: dateRange.value.from,
  until: dateRange.value.to,
});

const emitChange = () => emit('change', currentFilters());
const debouncedEmitChange = debounce(emitChange, 400);

const onTextInput = e => {
  q.value = e.target.value;
  debouncedEmitChange();
};
</script>

<template>
  <div class="flex flex-wrap items-center gap-2 pb-3">
    <input
      type="search"
      class="reset-base outline-none flex-1 min-w-[10rem] h-8 px-3 rounded-lg border border-solid border-n-strong bg-n-solid-1 text-sm text-n-slate-12 placeholder:text-n-slate-10"
      :placeholder="t('CONTACT_PANEL.TIMELINE.SEARCH_PLACEHOLDER')"
      :value="q"
      @input="onTextInput"
    />
    <SearchInboxSelector
      v-model="inboxId"
      :label="t('CONTACT_PANEL.TIMELINE.FILTER_INBOX')"
      @change="emitChange"
    />
    <SearchDateRangeSelector v-model="dateRange" @change="emitChange" />
  </div>
</template>
